import { Trophy } from "@similarweb/icons";
import { BaseCell, TextCell } from "@similarweb/pro-logic-components";
import { colorsPalettes } from "@similarweb/styles";
import { Flex, Text } from "@similarweb/ui-components/foundations";

import { NO_DATA_SIGN } from "app/filters/const";
import { abbrNumberFilter } from "app/filters/ngFilters";

export type LeaderValueCellProps = {
    dataAutomation?: string;
    isLeader: boolean;
    value?: number | null;
};

export const LeaderValueCell = ({ dataAutomation, isLeader, value }: LeaderValueCellProps) => {
    if (value == null) {
        return <TextCell dataAutomation={dataAutomation}>{NO_DATA_SIGN}</TextCell>;
    }

    return (
        <BaseCell dataAutomation={dataAutomation}>
            <Flex
                alignItems="center"
                gap="10px"
                justifyContent="end"
            >
                {isLeader ? (
                    <Trophy
                        size="xs"
                        color={colorsPalettes.yellow[400]}
                    />
                ) : null}
                <Text fontVariant="input2">{abbrNumberFilter()(value)}</Text>
            </Flex>
        </BaseCell>
    );
};
